import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel"]

  connect() {
    this.isOpen = false
  }

  toggle() {
    this.isOpen = !this.isOpen
    this.panelTarget.classList.toggle("hidden", !this.isOpen)
    this.panelTarget.classList.toggle("flex", this.isOpen)
  }
}
